export default __webpack_public_path__ + "assets/images/dc6a94561b9b215b12f7706cb20029fe.jpg";